export default __webpack_public_path__ + "static/media/img_1_1.8394ca5f.png";